import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import "@/shared/styles/globals.css";
import AppProviders from "@/providers/AppProviders";
import { router } from "@/routerConfig";
import { initPostHog } from "@/shared/analytics/initPostHog";
import { reportReactError } from "@/shared/logging/reportReactError";

const faviconHref = "/assets/favicon.ico";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element '#root' was not found.");
}

const existingFavicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
const faviconLink = existingFavicon ?? document.createElement("link");
faviconLink.rel = "icon";
faviconLink.type = "image/x-icon";
faviconLink.href = faviconHref;

if (!existingFavicon) {
  document.head.appendChild(faviconLink);
}

initPostHog();

createRoot(container, {
  onCaughtError: (error, errorInfo) => reportReactError("caught", error, errorInfo),
  onUncaughtError: (error, errorInfo) => reportReactError("uncaught", error, errorInfo),
  onRecoverableError: (error, errorInfo) => reportReactError("recoverable", error, errorInfo),
}).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
